import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type MetricsService from 'garaje/services/metrics';
import type SigmaUrlService from 'garaje/services/sigma-url';
import type StateService from 'garaje/services/state';
import urlBuilder from 'garaje/utils/url-builder';
import { alias } from 'macro-decorators';

export default class AnalyticsDesksController extends Controller {
  @service declare flashMessages: FlashMessagesService;
  @service declare state: StateService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare metrics: MetricsService;
  @service declare sigmaUrl: SigmaUrlService;

  @alias('state.desksSubscription') desksSubscription: StateService['desksSubscription'] = null;
  @alias('state.desksSubscription.isBasicPlan') isBasicPlan: boolean = true;

  @action
  trackUpgradeDesksPlan(): void {
    this.metrics.trackEvent('Clicked a button to upgrade plan from hazed analytics modal');
  }

  get iframeUrl(): Promise<string | undefined> {
    const companyId = this.state?.currentCompany?.id;
    const locationId = this.state?.currentLocation?.id;

    if (!companyId || !locationId) {
      return Promise.resolve(undefined);
    }

    if (!this.featureFlags.isEnabled('sigma-embedded-analytics'))
      return Promise.resolve(urlBuilder.embeddedDesksLocationAnalyticsUrl(companyId, locationId));
    return this.getSigmaIframeUrl(companyId, locationId);
  }

  async getSigmaIframeUrl(companyId: string, locationId: string): Promise<string | undefined> {
    try {
      return this.sigmaUrl.getLocationSigmaUrl(companyId, locationId, 'desks');
    } catch (e) {
      this.flashMessages.showAndHideFlash('error', 'Error getting Sigma url');
      // eslint-disable-next-line no-console
      console.error(e);
      return;
    }
  }
}
